/**
 * Room ID Generator
 *
 * Generates unique, URL-safe room identifiers for PartyKit sessions.
 * Uses nanoid for collision-resistant, cryptographically random IDs.
 *
 * PartyKit rooms are created automatically when clients connect,
 * so we only need client-side ID generation - no server API required.
 */

import { nanoid } from 'nanoid';

/**
 * Generate a unique room ID for a game session
 *
 * @param {number} [length=10] - Length of the generated ID (default: 10)
 * @returns {string} URL-safe room identifier
 *
 * @example
 * const roomId = generateRoomId();
 * // Returns: "V1StGXR8_Z"
 *
 * const customLength = generateRoomId(15);
 * // Returns: "V1StGXR8_ZnBqwG"
 */
export function generateRoomId(length = 10) {
  return nanoid(length);
}
